module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lang-switcher",
    class: [_vm.menuOpenMobile ? 'lang-switcher--open' : ''],
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "lang-button lang-button--main",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.opened = !_vm.opened
      }
    }
  }, [_c('div', {
    staticClass: "lang-button__content"
  }, [_c('span', {
    staticClass: "lang-button__label"
  }, [_vm._v(_vm._s(_vm.$t(_vm.currentLang.label)))])])]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.opened || _vm.menuOpenMobile) ? _c('div', {
    staticClass: "langs"
  }, _vm._l((_vm.availableLangs), function(lang) {
    return _c('router-link', {
      key: lang.id,
      staticClass: "lang-button",
      attrs: {
        "to": _vm.getLangUrl(lang.id)
      },
      nativeOn: {
        "click": function($event) {
          _vm.onLangChange($event)
        }
      }
    }, [_c('div', {
      staticClass: "lang-button__content"
    }, [_c('span', {
      staticClass: "lang-button__label"
    }, [_vm._v(_vm._s(_vm.$t(lang.label)))])])])
  })) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-abb9619a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layout/elements/lang-switcher.vue
// module id = 501
// module chunks = 0